class EventUtils {
  static readonly keyCodes = {
    BACKSPACE: 'Backspace',
  };

  static isDeleting = (event: React.KeyboardEvent) => event.key === EventUtils.keyCodes.BACKSPACE;
}

export default EventUtils;
